import React, {useEffect, useState} from 'react';
import { Currency, PosterSize, Region, usePosterSizeQuery, useRegionsQueryQuery, useUpdateAreaBookingRegionPricingMutation } from '../../generated/graphql';
import { FieldTable } from '../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import { useDiaForm, DiaFormSubmitCallbackProps } from '../../components/dia-form';
import {ModalWindow} from "../../components/ModalWindow";
import {Button} from "@mui/material";
import {Cancel, Save} from "@mui/icons-material";
import { useToast } from "../../contexts/toast";

type Row = Region & {posterData?: {id?:string|number,unit_value?:number,currency?:Currency} }; 

type Rows = {
    rows: Row[]
};

const columns: FieldTableColumnProps<Row>[]=[
    {
        header: 'Region',
        accessor: 'regionType.name',
        dataType:'default',
        options: {
            getValue:({row})=>row?row.regionType?.name+' / '+row.name:''
        }
    },
    {
        header:'Price per poster',
        accessor:'posterData.unit_value',
        dataType:'currency',
        options: {
            currency:{
                accessor:'posterData.currency'
            }
        }
    }
]



export function PosterSizesRegionModal(props:{posterSize:PosterSize|null,close:Function}) {
    function cancel() {
        props.close();
    }
    const { toast, dismiss } = useToast();
    //const [data,setData] = useState([]);
    const isShown = !!(props.posterSize);
    const regionData = useRegionsQueryQuery({skip:!isShown});
    const regionalPosterData = usePosterSizeQuery({variables:{id:props.posterSize?.id},skip:!isShown,fetchPolicy:'no-cache'});
    const [mutation] = useUpdateAreaBookingRegionPricingMutation({errorPolicy:'all'});


    const [rows,setRows] = useState<Rows>(null);

    const diaForm = useDiaForm<Rows, any>({
        inputValues:rows,
        onSubmit: doSubmit,
        loaded: !regionData.loading && !regionalPosterData.loading
    });
    function confirm() {
        diaForm.handleSubmit();
    }
    useEffect(()=>{
        if(!regionData.data || !regionalPosterData.data){
            setRows(null);
//            diaForm.initialize([],[],null);
            return;
        } 
        const posterData = {};
        regionalPosterData.data.posterSize.areaBookingRegionPricing.forEach((regionalPosterDataRow) => {
            posterData[regionalPosterDataRow.region.id] = regionalPosterDataRow;
        });
        const newData = regionData.data.regions.data.map((regionDataRow)=> {
            const p:Row = {...regionDataRow};
            if(!posterData[regionDataRow.id]) {
                p.posterData = {};
            } else {
                p.posterData = posterData[regionDataRow.id];
            }
            return p;
        });
        setRows({rows:newData});
//        diaForm.initialize({rows:newData},null,null);
    },[regionalPosterData.loading,regionData.loading,regionData.data,regionalPosterData.data]);
    async function doSubmit({values,initialValues}:DiaFormSubmitCallbackProps<Rows>) {
        const creates = [];
        const updates = [];
        values.rows.forEach((row,idx) => {
            if(!row.posterData) return;
            if(!row.posterData.id) {
                if(row.posterData.unit_value) {
                    creates.push({posterSize:{connect:props.posterSize.id},region:{connect:row.id},currency:{connect:row.posterData.currency?.id??null},unit_value:row.posterData.unit_value});
                }
                return;
            }
            const initialRow = initialValues.rows[idx];
            if(row.posterData.unit_value!= initialRow.posterData.unit_value || (row.posterData.currency?.id != initialRow.posterData.currency?.id)) {
                updates.push({id:row.posterData.id,currency:{connect:row.posterData.currency?.id??null},unit_value:row.posterData.unit_value});
            }
        });
        await mutation({variables:{update:{
            update:updates,
            create:creates
        }}}).then((result)=>{
            let hasError = false;
            if(result.errors) {
                result.errors.forEach((error)=>{
                    toast(error.message,{variant:'error'});
                });
                hasError = true;
            }
            if(!hasError) {
                toast('Poster Prices updated successfully',{variant:'success'});
                props.close();
            }
        });
        
    }
    //console.log('data is',data,diaForm.ready);
    return (
        <ModalWindow isOpen={!!isShown} onClose={null} header={
            'Poster Region Rates for '+(props.posterSize?.name)
        } actions={<>
            <Button size="large" color="warning" onClick={cancel}><Cancel/>Cancel</Button>
            <Button size="large" variant="contained" onClick={confirm}><Save/>Save</Button>
        </>
        }>
    <FieldTable name="rows" className="postersizes__region-prices-modal__table"
    defaultSort={[{name:'regionType.name',asc:true},{name:'name',asc:true}]}
    loading={diaForm.status=='loading'} columns={columns} hasDelete={false} form={diaForm}/>
</ModalWindow>);
}